'use client';

import useSWR from 'swr';
import { fetcher } from '@/shared/api/fetcher';
import { useCurrentLocale } from '@locales/client';

export function useTranslations() {
  const lang = useCurrentLocale();
  
  const { data, error, isLoading } = useSWR(
    lang ? `/translations?lang=${lang}` : null,
    fetcher
  );

  return {
    translations: data,
    isError: error,
    isLoading,
  };
}